import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PopupContextType {
	isPopupVisible: boolean;
	setPopupVisible: (visible: boolean) => void;
	isAdTemplateModalOpen: boolean;
	setAdTemplateModalOpen: (visible: boolean) => void;
}

const PopupContext = createContext<PopupContextType | undefined>(undefined);

export const PopupProvider: React.FC<{ children: ReactNode }> = ({
	children,
}) => {
	const wasPopupShown = sessionStorage.getItem('popupClosed') === 'true';

	const [isPopupVisible, setPopupVisible] = useState(!wasPopupShown);
	const [isAdTemplateModalOpen, setAdTemplateModalOpen] = useState(false);

	return (
		<PopupContext.Provider
			value={{
				isPopupVisible,
				setPopupVisible,
				isAdTemplateModalOpen,
				setAdTemplateModalOpen,
			}}
		>
			{children}
		</PopupContext.Provider>
	);
};

export const usePopup = (): PopupContextType => {
	const context = useContext(PopupContext);
	if (!context) {
		throw new Error('usePopup must be used within a PopupProvider');
	}
	return context;
};
